export default "__VITE_ASSET__CoxR_P9p__"